// extracted by mini-css-extract-plugin
export default {"title":"Settings_title__PjxhA","staticInput":"Settings_staticInput__6RRCv"};